import React from 'react';

export default function InsetList(props) {
  return (
    <ul className="footer-contact-list" aria-label="contacts">
      { props.data.map((item, index) => (
        <li className="footer-contact-item" key={index}>
          <span className="footer-contact-icon" aria-hidden="true">
            {item.icon}
          </span>
          {item.email && <a href={`mailto:${item.text}`}>{item.text}</a>}
          {item.phone && <a href={`tel:${item.text}`}>{item.text}</a>}
          {item.default && <span>{item.text}</span>}
        </li>
      )) }
    </ul>
  );
}
